import React, { useRef, useEffect } from "react"
import "../components/pjm-glance.scss"
import { gsap } from "gsap"
import VisibilitySensor from 'react-visibility-sensor'

export default function PjmGlance(props) {
    const bubbles = useRef([]);

    useEffect(() => {
        for(let x = 0; x < bubbles.current.length; x++) {
            gsap.set(bubbles.current[x], {opacity: 0});
        }
    }, []);

    function bubblesAnimation() {
        let tl = gsap.timeline({paused: true})
        .fromTo(bubbles.current[0], {x: -300, y: -100, opacity: 0}, {x: 0, y: 0, opacity: 1, duration: 1.1, ease: 'elastic'}, "-=1.05")
        .fromTo(bubbles.current[1], {x: 0, y: -300, opacity: 0}, {x: 0, y: 0, opacity: 1, duration: 1.1, ease: 'elastic'}, "-=1.05")
        .fromTo(bubbles.current[2], {x: 300, y: -100, opacity: 0}, {x: 0, y: 0, opacity: 1, duration: 1.1, ease: 'elastic'}, "-=1.05")
        .fromTo(bubbles.current[3], {x: -300, y: 0, opacity: 0}, {x: 0, y: 0, opacity: 1, duration: 1.1, ease: 'elastic'}, "-=1.05")
        .fromTo(bubbles.current[4], {x: -300, y: 0, opacity: 0}, {x: 0, y: 0, opacity: 1, duration: 1.1, ease: 'elastic'}, "-=1.05")
        .fromTo(bubbles.current[5], {x: 500, y: 50, opacity: 0}, {x: 0, y: 0, opacity: 1, duration: 1.1, ease: 'elastic'}, "-=1.05")
        .fromTo(bubbles.current[6], {x: 400, y: 100, opacity: 0}, {x: 0, y: 0, opacity: 1, duration: 1.1, ease: 'elastic'}, "-=1.05")
        .fromTo(bubbles.current[7], {x: -300, y: 200, opacity: 0}, {x: 0, y: 0, opacity: 1, duration: 1.1, ease: 'elastic'}, "-=1.05")
        .fromTo(bubbles.current[8], {x: 0, y: 200, opacity: 0}, {x: 0, y: 0, opacity: 1, duration: 1.1, ease: 'elastic'}, "-=1.05")
        tl.play(0);
    }

    function onChange(isVisible) {
        console.log(isVisible, 'fired');
        if(isVisible) {
            bubblesAnimation();    
        }
    }

    return (
        <VisibilitySensor partialVisibility={true} minTopValue={500} onChange={onChange}>
        <div className="pjm-glance">
            <div className="pjm-glance__inner">
                <div className="row row-wrapper text--center p-b-60">
                    <div className="col-xs-12">
                        <div className="text--outline text--white title--super">PJM AT A</div>
                        <div className="large--title text--title text--white">GLANCE</div>
                    </div>
                </div>
                
                    <div className="row row-wrapper text--center rel">
                        <div className="col-xs-12">
                            <div ref={(element) => {bubbles.current[0] = element}} className="circle-3 membership">
                                <div className="info">
                                    <div className="title">MEMBERSHIP</div>
                                    <div className="stat text--title stat--small">1,060</div>
                                </div>
                            </div>
                            <div ref={(element) => {bubbles.current[1] = element}} className="circle-1 transmission-lines">
                                <div className="info">
                                    <div className="title">TRANSMISSION LINES</div>
                                    <div className="stat text--title">85,103 MILES</div>
                                </div>
                            </div>
                            <div ref={(element) => {bubbles.current[2] = element}} className="circle-2 states-served">
                                <div className="info">
                                    <div className="title">STATES SERVED</div>
                                    <div className="stat text--title stat--small">13 + D.C.</div>
                                </div>
                            </div>
                            <div ref={(element) => {bubbles.current[3] = element}} className="circle-4 annual-energy">
                                <div className="info">
                                    <div className="title">ANNUAL ENERGY</div>
                                    <div className="stat text--title stat--small">782,683 GWh</div>
                                </div>
                            </div>
                            <div ref={(element) => {bubbles.current[4] = element}} className="circle-2 square-miles-of-territory">
                                <div className="info">
                                    <div className="title">SQUARE MILES OF TERRITORY</div>
                                    <div className="stat text--title">368,906</div>
                                </div>
                            </div>
                            <div ref={(element) => {bubbles.current[5] = element}} className="circle-4 peak-demand">
                                <div className="info">
                                    <div className="title">PEAK DEMAND</div>
                                    <div className="stat text--title stat--small">165,563 MW</div>
                                </div>
                            </div>
                            <div ref={(element) => {bubbles.current[6] = element}} className="circle-3 generating-capacity">
                                <div className="info">
                                    <div className="title">GENERATING CAPACITY</div>
                                    <div className="stat text--title">185,442 MW</div>
                                </div>
                            </div>
                            <div ref={(element) => {bubbles.current[7] = element}} className="circle-1 annual-billing">
                                <div className="info">
                                    <div className="title">ANNUAL BILLINGS</div>
                                    <div className="stat text--title stat--small">$54.1 BILLION</div>
                                </div>
                            </div>
                            <div ref={(element) => {bubbles.current[8] = element}} className="circle-1 population">
                                <div className="info">
                                    <div className="title">POPULATION</div>
                                    <div className="stat text--title stat--small">65+ MILLION</div>
                                </div>
                            </div>
                        </div>
                    </div>
                
            </div>
        </div>  
        </VisibilitySensor>      
    )
}

